module.exports = __webpack_public_path__ + "img/practice-4.320b1ec8.jpg";